import { kdTree } from '__common/vendor/kdTree';
import { calcDistanceOfTwoPoints } from '__common/calculations/distanceBetweenTwoPoints';

const KD_TREE_DIMENSIONS = ['x', 'y', 'corner'];

let stickPoints = new kdTree([], calcDistanceOfTwoPoints, KD_TREE_DIMENSIONS);
let stickPointCount = 0;

export function insertKdTreePoints(points: stickyPoints[], groupId: number, panelId: number) {
  points.forEach((point) => {
    point.groupId = groupId;
    point.panelId = panelId;
    stickPoints.insert(point);
    stickPointCount += 1;
  });
}

export function removeKdTreePoints(points: stickyPoints[]) {
  points.forEach((point) => {
    stickPoints.remove(point);
    stickPointCount = Math.max(0, stickPointCount - 1);
  });
}

interface kdTreePoint {
  corner: number;
  groupId: number;
  panelId: number;
  x: number;
  y: number;
}

export function nearestKdTreePoint(point: { x: number, y: number }, count = 1, distance = 50): [kdTreePoint, number][] {
  return stickPoints.nearest(point, count, distance);
}

export function isKdTreeEmpty() {
  return stickPointCount === 0;
}

export function resetKdTree() {
  stickPoints = new kdTree([], calcDistanceOfTwoPoints, KD_TREE_DIMENSIONS);
  stickPointCount = 0;
}
